import { CertificationInterface, CertificationState } from "../types";

export const canSignCertification = ({
  certification,
  loggedInStaffId,
}: {
  certification: CertificationInterface;
  loggedInStaffId: number;
}): boolean =>
  certification.state === CertificationState.completed &&
  (certification.assigneeId === loggedInStaffId ||
    certification.internalCertifierId === loggedInStaffId);
